import React, { useEffect } from "react";
import {
  ActionIcon,
  Box,
  Menu,
  ScrollArea,
  Table,
  Text,
  createStyles,
} from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import RecordNotFound from "../../RecordNotFound";
import TableLoader from "../../TableLoader";
import { BiDotsVerticalRounded } from "react-icons/bi";
import swal from "sweetalert";
import {
  getAllBillingConsumers,
  getAllBillingInvoices,
  getAllBillingPaidInvoices,
  getAllBillingRecurringInvoices,
  getAllCashAndChequeInvoice,
  removeBillingInvoice,
  resendInvoiceEmail,
} from "../../../services/billinginvoice";
import EditInvoice from "./EditInvoice";
import CustomInvoicePagination from "../../Pagination/CustomInovicePagination";
import MarkAsPaid from "./MarkAsPaid";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      // backgroundColor: "#F2F2F2",
      color: "#000 !important",
    },
    "& th:first-of-type": {
      borderTopLeftRadius: "16px !important",
      borderBottomLeftRadius: "16px !important",
    },
    "& th:last-of-type": {
      borderTopRightRadius: "16px !important",
      borderBottomRightRadius: "16px !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
    borderRadius: "15px",
  },
  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
  tableHeader: {
    borderBottom: "none !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
  },
  tablebody: {
    borderBottom: "none !important",
    fontSize: "14px !important",
    // fontWeight: "700 !important",
  },
}));

const PreviousInvoices = ({ data }) => {
  const { classes, cx } = useStyles();
  // const { patients, loading } = useSelector((state) => state.patient);
  const [scrolled, setScrolled] = useState(false);
  const { allbillinginvoices, CashandChequeInvoice, loading } = useSelector(
    (state) => state.billinginvoiceReducer
  );

  const [editinvoice, setEditinvoice] = useState(false);
  const { profile } = useSelector((state) => state?.profile);
  const [invoice, setInvoice] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [markasPaidOpen, setMarkAsPaidOpen] = useState(false);
  const [paymentdetials, setPaymentdetials] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  console.log("currentPage", currentPage);

  const onEdit = (data) => {
    setInvoice(data);
    setEditinvoice(true);
  };

  const marksaspaid = async (item) => {
    console.log("item", item);
    setMarkAsPaidOpen(true);
    setPaymentdetials(item);

    // let payload = {
    //   admin: profile.user.id,
    //   invoiceid: data.id,
    // };

    // console.log("payload", payload);

    // const res = await UpdateBillingInvoicesStatus(payload);

    // if (res.status === 200) {
    //   getAllBillingInvoices();
    //   swal({
    //     title: `Invoice updated successfully`,
    //     text: "Invoice updated successfully",
    //     dangerMode: false,
    //     icon: "success",
    //   });
    // }

    // setInvoice(data);
    // setEditinvoice(true);
  };

  const ResendInvoice = async (data) => {    
    let payload = {
      admin: profile.user.id,
      invoiceid: data._id,
    };

    console.log("payload", payload);

    const res = await resendInvoiceEmail(payload);

    if (res.status === 200) {
      getAllBillingInvoices();
      swal({
        title: `Invoice email resend successfully`,
        text: "Invoice email resend successfully",
        dangerMode: false,
        icon: "success",
      });
    }
  };

  useEffect(() => {
    getAllBillingInvoices({ page: currentPage });
    getAllCashAndChequeInvoice();
  }, [currentPage]);

  useEffect(() => {
    getAllBillingConsumers();
    let payload = {
      page: 1,
    };
    getAllBillingInvoices(payload);
    getAllBillingRecurringInvoices(payload);
    getAllBillingPaidInvoices(payload);
  }, []);

  const remove = async (id) => {
    let payload = {
      id,
    };

    console.log("payload", payload);

    // event.stopPropagation();
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removeBillingInvoice(payload);
  };

  return (
    <>
      <ScrollArea
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        sx={{
          marginTop: "30px",
          minHeight: "300px",
          outline: "2px solid #1018280D ",
          borderRadius: 5,
        }}
      >
        <Table
          // withBorder
          highlightOnHover
          enableStickyHeader
          sx={{
            fontFamily: "Inter",
            borderRadius: "5px",
          }}
          fontSize={"sm"}
          verticalSpacing={"md"}
        >
          <thead
            className={cx(classes.header, { [classes.scrolled]: scrolled })}
          >
            <tr>
              <th style={{ minWidth: "120px" }} className={classes.tableHeader}>
                Status
              </th>
              <th
                style={{ minWidth: "160px", fontWeight: "700" }}
                className={classes.tableHeader}
              >
                Date
              </th>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Invoice #
              </th>

              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Due Date
              </th>
              <th style={{ minWidth: "180px" }} className={classes.tableHeader}>
                Customer Name
              </th>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Amount
              </th>
              <th style={{ minWidth: "140px" }} className={classes.tableHeader}>
                Customer Email
              </th>
              <th style={{ minWidth: "80px" }} className={classes.tableHeader}>
                Action
              </th>
            </tr>
          </thead>

          <tbody className={cx(classes.tablebody)}>
            {loading ? (
              <tr>
                <td colSpan={1000}>
                  <TableLoader />
                </td>
              </tr>
            ) : allbillinginvoices &&
              allbillinginvoices?.billinginvoice?.length > 0 ? (
              // allbillinginvoices?.billinginvoice
              [...allbillinginvoices.billinginvoice]
                .sort((a, b) => {
                  return new Date(b.createdAt) - new Date(a.createdAt);
                })
                ?.map((row, index) => (
                  <tr key={index}>
                    <td>{row.status.toUpperCase()}</td>
                    <td>
                      {" "}
                      {row?.createdAt
                        ? new Date(row?.createdAt).toLocaleDateString("en-US")
                        : "Date Not Available"}
                    </td>
                    <td>{row.invoiceNumber}</td>
                    <td>
                      {row?.invoiceDueDate
                        ? new Date(row?.invoiceDueDate).toLocaleDateString(
                            "en-US"
                          )
                        : " Due Date Not Available"}
                    </td>
                    <td>{row?.consumer?.name}</td>
                    <td>${row.totalAmount}</td>
                    <td>{row.consumer?.email}</td>
                    <td style={{ display: "flex", justifyContent: "center" }}>
                      <Menu shadow="md" position="left" zIndex={"1000"}>
                        <Menu.Target>
                          <ActionIcon className={classes.marginTop}>
                            <BiDotsVerticalRounded
                              id="vertical-dots"
                              size={20}
                              color="#000"
                            />
                          </ActionIcon>
                        </Menu.Target>
                        <Menu.Dropdown>
                          <Menu.Item
                            id="open-link"
                            // icon={<IconEye size={14} />}
                            onClick={() => {
                              onEdit(row);
                              setIsPreview(true);
                            }}
                          >
                            View
                          </Menu.Item>
                          {/* <Menu.Item icon={<IconDownload size={14} />}>Download</Menu.Item> */}

                          {/* {CashandChequeInvoice?.cashChequeInvoices?.find(
                            (item) =>
                              // console.log('item',item)

                            

                              item.invoiceId === row.id &&
                              row?.status !== "Paid"
                          ) && (
                            <Menu.Item onClick={() => marksaspaid()}>
                              Mark as Paid
                            </Menu.Item>
                          )} */}

                          {CashandChequeInvoice?.cashChequeInvoices?.find(
                            (item) =>
                              item?.invoiceId === row?.id &&
                              row?.status !== "Paid"
                          ) && (
                            <Menu.Item
                              onClick={() =>
                                marksaspaid(
                                  CashandChequeInvoice?.cashChequeInvoices?.find(
                                    (item) =>
                                      item.invoiceId === row.id &&
                                      row?.status !== "Paid"
                                  )
                                )
                              }
                            >
                              Mark as Paid
                            </Menu.Item>
                          )}

                          {row?.status !== "Paid" ? (
                            <>
                              <Menu.Item
                                // icon={<IconEdit size={14} />}
                                // onClick={() => onEdit(row)}
                                //  onClick={() => onEdit(row)}
                                onClick={() => ResendInvoice(row)}
                              >
                                Resend
                              </Menu.Item>
                            </>
                          ) : null}
                          
                          {row?.status !== "Paid" ? (
                            <>
                              <Menu.Item
                                // icon={<IconEdit size={14} />}
                                // onClick={() => onEdit(row)}
                                //  onClick={() => onEdit(row)}
                                onClick={() => remove(row?.id)}
                              >
                                Delete
                              </Menu.Item>
                            </>
                          ) : null}



                          {/* <Menu.Item icon={<IconEdit size={14} />} onClick={open}> */}
                        </Menu.Dropdown>
                      </Menu>
                    </td>
                  </tr>
                ))
            ) : (
              <tr>
                <td colSpan={1000}>
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      height: "75vh",
                      gap: "8rem",
                    }}
                  >
                    <RecordNotFound />
                    <Text className="notFoundText">
                      You don&apos;t have any record, click on “Create Invoices”
                    </Text>
                  </Box>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </ScrollArea>
      <CustomInvoicePagination
        data={allbillinginvoices?.count}
        itemsPerPage={10}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
      />

      <EditInvoice
        editinvoice={editinvoice}
        setEditinvoice={setEditinvoice}
        invoice={invoice}
        setInvoice={setInvoice}
        isPreview={isPreview}
        setIsPreview={setIsPreview}
      />

      <MarkAsPaid
        markasPaidOpen={markasPaidOpen}
        setMarkAsPaidOpen={setMarkAsPaidOpen}
        paymentdetials={paymentdetials}
      />
    </>
  );
};

export default PreviousInvoices;
